import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios';
// import LazyLoad from 'react-lazyload';
import Homepage from './HomePage'
import { GuestComp } from './GuestComp'
import { QuickComp } from './QuickComp'
import PodcastComp from './PodcastComp'
import { API_ROOT, webPath } from '../apiconfig';

import { Helmet } from 'react-helmet';
import AdCarousel from '../ReusableComp/Carasoul';



function MainPageComp() {


  const [advertisementData, setAdvertisementData] = useState([]);
  const [footerAdvertise, setFooterAdvertise] = useState([]);
  const [className1, setClassName1] = useState("");

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName1("");
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName1("loaded1");
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          window.removeEventListener("scroll", handleScroll);
        }
      }, currentSection * 70);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setSectionClassName();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const fetchAdvertisementData = async () => {
      try {
        const response = await axios.get(`${API_ROOT}/api/advertisement/get_active`);
        setAdvertisementData(response.data);
        setFooterAdvertise(response.data.filter(item => item.banner_type === "Footer-3"))

      } catch (error) {
        console.error('Error fetching advertisement data:', error);
      }
    };

    fetchAdvertisementData();
  }, []);

  const pageTitle = "TalkGovTech | News & Insights on Government Technology";

  return (
    <div style={{ overflow: "hidden" }} className='no-gutters'>

      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Stay updated with TalkGovTech, your source for news, articles, and podcasts on digital innovation, AI, and emerging technologies in government." />
        <meta name="title" property="og:title" content={pageTitle} />
        <meta property="og:type" content="PostDetails" />
        <meta name="image" property="og:image" content="https://talkgovtech.com/static/media/abcGov.png" />
        <meta name="description" property="og:description" content="Stay updated with TalkGovTech, your source for news, articles, and podcasts on digital innovation, AI, and emerging technologies in government." />
        <meta property="og:url" content="https://talkgovtech.com/" />
        <meta property="og:image:width" content="844" />
        <meta property="og:image:height" content="172" />
        <meta property="og:image:type" content="image/png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="https://x.com/TalkGovTech"></meta>
        <link rel="canonical" href="https://talkgovtech.com/" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content="Stay updated with TalkGovTech, your source for news, articles, and podcasts on digital innovation, AI, and emerging technologies in government." />
        <meta name="twitter:image" content="https://talkgovtech.com/static/media/TalkFintech.0d98293385406252f383.webp" />
      </Helmet>


      <Homepage />



      <PodcastComp />

      <GuestComp />




      <QuickComp />






      <div className="container container-max">
        <div className="row mt-5 spaceincontentbottm">
          <div className="col-md-12 mb-2">
            {/* <div >
            {advertisementData && advertisementData.length > 0 && (
             <a href={`${advertisementData[2]?.dest_url}`} target='_blank'> <img
                style={{ width: "100%", height:"auto" }}
                srcSet={`${webPath}${advertisementData[2]?.banner_img}?w=320 320w, ${webPath}${advertisementData[2]?.banner_img}?w=640 640w, ${webPath}${advertisementData[2]?.banner_img}?w=1280 1280w`}
                sizes="(max-width: 640px) 100vw, 640px"  
            
                alt={advertisementData[2].banner_name}  aria-label={advertisementData[2]?.banner_name}
                loading="lazy" width="640" height="360" /> </a>
            )}
            </div> */}
            <AdCarousel ads={footerAdvertise} className={className1} />
          </div>
        </div>
      </div>



    </div>
  )
}

export default MainPageComp

